import React from 'react';
import { func, bool } from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import styles from './styles.scss';
import { createTheme, MuiThemeProvider } from '@material-ui/core';

export const customTheme = createTheme({
  overrides: {
    MuiDialogContent: {
      root: {
        padding: '0px 24px 24px',
      }
    },
    MuiDialogContentText: {
      root: {
        marginBottom: 0  
      }
    },
    MuiGrid: {
      "grid-xs-12": {
        padding: 12,
      },
      container: {
        width: 'calc(100% + 24px)',
        margin: -24,
      }
    },
    MuiButton: {
      label: {
        color: '#2196f3',
      }
    },
    MuiDialogTitle: {
      root: {
        padding: '15px 24px 8px',
      }
    },
    MuiDialogActions: {
      root: {
        padding: 0,
        margin: '8px 4px',
      }
    }
  }
})

export const keyboardShortcutsList = [
  {
    shortcutsTitle: 'Playback',
    shortcuts: [
      {
        shortKeyTitle: 'Play/Pause',
        buttonShortcuts: ['space bar']
      },
      {
        shortKeyTitle: 'Add 30 seconds before',
        buttonShortcuts: ['←','or','A']
      },
      {
        shortKeyTitle: 'Add 30 seconds after',
        buttonShortcuts: ['→','or','D']
      },
      {
        shortKeyTitle: 'Increase playback speed',
        buttonShortcuts: ['Shift','+','→','or','W']
      },
      {
        shortKeyTitle: 'Decrease playback speed',
        buttonShortcuts: ['Shift','+','←','or','S']
      }
    ]
  },
  {
    shortcutsTitle: 'Other',
    shortcuts: [
      {
        shortKeyTitle: 'Reassign',
        buttonShortcuts: ['⌘','or','Ctrl','+','R']
      },
      {
        shortKeyTitle: 'Exclude',
        buttonShortcuts: ['⌘','or','Ctrl','+','X']
      },
      {
        shortKeyTitle: 'Include',
        buttonShortcuts: ['⌘','or','Ctrl','+','Q']
      },
    ]
  }
]
export default class KeyboardShortcutsModal extends React.Component {
  static propTypes = {
    onClose: func.isRequired,
    open: bool,
  };
  static defaultProps = {};
  
  drawButtonShortcuts(shortcuts) {
    const { buttonShortcuts, shortKeyTitle } = shortcuts;
    return (
      <Grid item xs={12} container alignItems="center">
        <Grid item xs={6} className={styles.shortKeyTitle}>
          {shortKeyTitle}
        </Grid>
        <Grid item xs={6} className={styles.shortKey}>
          {
            buttonShortcuts.map(shortcut => {
              if (shortcut === 'or' || shortcut === '+') {
                return <span className={styles.operator} key={`${shortKeyTitle}-${shortcut}`}>{shortcut}</span>
              }
              return <div className={styles.buttonShortcuts} key={`${shortKeyTitle}-${shortcut}`}>{shortcut}</div>
            })
          }
        </Grid>
      </Grid>
  )}

  render() {
    return (
      <MuiThemeProvider theme={customTheme}>
        <Dialog
          open={this.props.open}
          onClose={this.props.onClose}
          maxWidth="md"
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Keyboard Shortcuts</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Grid container spacing={24} className={styles.shortcutsContent}>
                {keyboardShortcutsList && keyboardShortcutsList.map(keyboardShortcuts => (
                  <Grid
                    item
                    xs={6}
                    container
                    alignContent="flex-start"
                    spacing={24}
                    key={keyboardShortcuts.shortcutsTitle}
                    className={styles.keyboardShortcutsContainer}
                  >
                    <Grid item xs={12} className={styles.shortcutsTitle}>
                      {keyboardShortcuts.shortcutsTitle}
                    </Grid>
                    {keyboardShortcuts.shortcuts.map(shortcuts => this.drawButtonShortcuts(shortcuts))}
                  </Grid>
                ))}
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.props.onClose}
              color="primary"
              autoFocus
              className={styles.closeButton}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </MuiThemeProvider>
    );
  }
}
